import React from 'react';
import { cn } from '../../utils/cn';
export function Table({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableElement>) {
  return <div className="relative w-full overflow-auto rounded-md border border-slate-200" data-id="element-306">
      <table className={cn('w-full caption-bottom text-sm text-left', className)} {...props} data-id="element-307" />
    </div>;
}
export function TableHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <thead className={cn('[&_tr]:border-b bg-slate-50', className)} {...props} data-id="element-308" />;
}
export function TableBody({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody className={cn('[&_tr:last-child]:border-0', className)} {...props} data-id="element-309" />;
}
export function TableRow({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement>) {
  return <tr className={cn('border-b border-slate-100 transition-colors hover:bg-slate-50/50 data-[state=selected]:bg-slate-100', className)} {...props} data-id="element-310" />;
}
export function TableHead({
  className,
  ...props
}: React.ThHTMLAttributes<HTMLTableCellElement>) {
  return <th className={cn('h-10 px-4 text-left align-middle font-medium text-slate-500 [&:has([role=checkbox])]:pr-0', className)} {...props} data-id="element-311" />;
}
export function TableCell({
  className,
  ...props
}: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cn('p-4 align-middle [&:has([role=checkbox])]:pr-0 text-slate-700', className)} {...props} data-id="element-312" />;
}